import { createSelector } from 'reselect';
import { DROPDOWN_TO_FILTER_MAP, DATE_LIST } from '../../filter-constants';

/**
 * Redux selectors for dropdown data
 */

const selectDropdownData = (state) => state.dropdownData;

/**
 * Selects only dropdown data for one list
 * References list types in filter-constants.js ie. CLASS_LIST
 * */
const selectDropdownDataByType = (type) =>
    createSelector([selectDropdownData], (dropdownData) =>
        dropdownData.find((d) => d.type === type)
    );

const selectDropdownDataDatalistByType = (type) =>
    createSelector([selectDropdownDataByType(type)], (dropdownItem) => {
        if (dropdownItem) {
            return dropdownItem.data;
        }
        return [];
    });

const selectSelectedOptionByType = (type) =>
    createSelector(
        [selectDropdownDataByType(type)],
        (dropdownItem) => dropdownItem && dropdownItem.selectedOption
    );

const selectAllSelectedOptions = createSelector(
    [selectDropdownData],
    (dropdownData) => {
        const selectedOptions = {};
        dropdownData.forEach((d) => {
            const { type, selectedOption } = d;
            const filter = DROPDOWN_TO_FILTER_MAP[d.type];
            if (type === DATE_LIST) {
                selectedOptions[filter] = selectedOption;
            } else {
                selectedOptions[filter] = {
                    id: selectedOption.value,
                    name: selectedOption.label
                };
            }
        });
        return selectedOptions;
    }
);

export default {
    selectDropdownData,
    selectDropdownDataByType,
    selectDropdownDataDatalistByType,
    selectAllSelectedOptions,
    selectSelectedOptionByType
};



// WEBPACK FOOTER //
// ./components/report-filters/redux/dropdown-data/dropdown-data-selectors.js